// Dashboard
export const FETCH_PROVIDER_DASHBOARD_INIT = "FETCH_PROVIDER_DASHBOARD_INIT";
export const FETCH_PROVIDER_DASHBOARD_SUCCESS = "FETCH_PROVIDER_DASHBOARD_SUCCESS";
export const FETCH_PROVIDER_DASHBOARD_FAILURE = "FETCH_PROVIDER_DASHBOARD_FAILURE";

// Profile
export const FETCH_PROVIDER_PROFILE_INIT = "FETCH_PROVIDER_PROFILE_INIT";
export const FETCH_PROVIDER_PROFILE_SUCCESS = "FETCH_PROVIDER_PROFILE_SUCCESS";
export const FETCH_PROVIDER_PROFILE_FAILURE = "FETCH_PROVIDER_PROFILE_FAILURE";

// Task List
export const FETCH_PROVIDER_TASKS_INIT = "FETCH_PROVIDER_TASKS_INIT";
export const FETCH_PROVIDER_TASKS_SUCCESS = "FETCH_PROVIDER_TASKS_SUCCESS";
export const FETCH_PROVIDER_TASKS_FAILURE = "FETCH_PROVIDER_TASKS_FAILURE";

// Task Detail
export const FETCH_PROVIDER_TASK_DETAIL_INIT = "FETCH_PROVIDER_TASK_DETAIL_INIT";
export const FETCH_PROVIDER_TASK_DETAIL_SUCCESS = "FETCH_PROVIDER_TASK_DETAIL_SUCCESS";
export const FETCH_PROVIDER_TASK_DETAIL_FAILURE = "FETCH_PROVIDER_TASK_DETAIL_FAILURE";

// Start Task
export const START_PROVIDER_TASK_INIT = "START_PROVIDER_TASK_INIT";
export const START_PROVIDER_TASK_SUCCESS = "START_PROVIDER_TASK_SUCCESS";
export const START_PROVIDER_TASK_FAILURE = "START_PROVIDER_TASK_FAILURE";

// Complete Task
export const COMPLETE_PROVIDER_TASK_INIT = "COMPLETE_PROVIDER_TASK_INIT";
export const COMPLETE_PROVIDER_TASK_SUCCESS = "COMPLETE_PROVIDER_TASK_SUCCESS";
export const COMPLETE_PROVIDER_TASK_FAILURE = "COMPLETE_PROVIDER_TASK_FAILURE";

// Upload Photo
export const UPLOAD_TASK_PHOTO_INIT = "UPLOAD_TASK_PHOTO_INIT";
export const UPLOAD_TASK_PHOTO_SUCCESS = "UPLOAD_TASK_PHOTO_SUCCESS";
export const UPLOAD_TASK_PHOTO_FAILURE = "UPLOAD_TASK_PHOTO_FAILURE";

// Clear states
export const CLEAR_PROVIDER_TASK_DETAIL = "CLEAR_PROVIDER_TASK_DETAIL";
export const CLEAR_PROVIDER_ERROR = "CLEAR_PROVIDER_ERROR";
